var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSushiHub)?_c('sushi-nav'):_vm._e(),_c('intro-header',{attrs:{"isSushi":_vm.isSushiHub}}),_c('div',[_c('div',{class:{ 'container':  !_vm.isSushiHub }},[_c('div',[_c(_vm.currentComponent,{tag:"component"})],1)])]),(_vm.isSushiHub)?_c('TermsAndCondition'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }